import { NavLink } from "react-router-dom";
import { Perfil } from "./Perfil";
import { Accordion, Card } from "react-bootstrap";
import { PATHS } from "../../utils/Constant";
import { useAppSelector } from "../../store/store";
import { RolElement } from "../../router/RolElement";
import { SCOPES_BY_ROLES } from "../../utils/ROLES";
interface Props {
  setShowNav: React.Dispatch<React.SetStateAction<boolean>>;
  showNav: boolean;
  screenIsSmall: boolean;
}
export const NavBar2 = ({ setShowNav, showNav, screenIsSmall }: Props) => {
  const width = showNav ? "16rem" : "0";
  const rol = useAppSelector(state => state.auth.rol);
  return (
    <div className="zindex-fixed d-flex position-fixed bg-uvilor-g">
      <nav
        className="nav-lateral d-flex flex-column bg-uvilor-g"
        style={{ width: width }}
      >
        <Perfil screenIsSmall={screenIsSmall} showBySmall={true} />
        <Accordion className="bg-uvilor-g border-0 nav-accordion">
          <div className="bg-uvilor-g border-0">
            <div
              className="bg-uvilor-g accordion-header card-header"
              style={{ padding: "1rem" }}
            >
              <NavLink
                onClick={() => setShowNav(false)}
                to="/"
                className="text-decoration-none text-white"
              >
                <span className="icon-home pe-2"> </span>Inicio
              </NavLink>
            </div>
          </div>
          <Accordion.Item eventKey="0" className="bg-uvilor-g border-0">
            <Accordion.Button
              as={Card.Header}
              className="bg-uvilor-g text-white accordion-header"
            >
              <span className="icon-cogs pe-2"> </span>Administración
            </Accordion.Button>
            <Accordion.Body>
              <ul>
                <li className="accordion-body">
                  <NavLink
                    onClick={() => setShowNav(false)}
                    className={({ isActive }) =>
                      `text-decoration-none ${isActive && "active"}`
                    }
                    to="rutas"
                  >
                    Rutas
                  </NavLink>
                  <NavLink
                    onClick={() => setShowNav(false)}
                    className={({ isActive }) =>
                      `text-decoration-none ${isActive && "active"}`
                    }
                    to="conductores"
                  >
                    Conductores
                  </NavLink>
                  <NavLink
                    onClick={() => setShowNav(false)}
                    className={({ isActive }) =>
                      `text-decoration-none ${isActive && "active"}`
                    }
                    to="cupos"
                  >
                    Cupos
                  </NavLink>
                  <NavLink
                    onClick={() => setShowNav(false)}
                    className={({ isActive }) =>
                      `text-decoration-none ${isActive && "active"}`
                    }
                    to="proveedores"
                  >
                    Proveedores
                  </NavLink>
                  <NavLink
                    onClick={() => setShowNav(false)}
                    className={({ isActive }) =>
                      `text-decoration-none ${isActive && "active"}`
                    }
                    to="pesos"
                  >
                    Pesos
                  </NavLink>
                </li>
              </ul>
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="1" className="bg-uvilor-g border-0">
            <Accordion.Button
              as={Card.Header}
              className="bg-uvilor-g text-white accordion-header"
            >
              <span className="icon-users pe-2"> </span>Proveedores
            </Accordion.Button>
            <Accordion.Body>
              <ul>
                <li className="accordion-body">
                  <NavLink
                    onClick={() => setShowNav(false)}
                    className={({ isActive }) =>
                      `text-decoration-none ${isActive && "active"}`
                    }
                    to={PATHS.REPORTES.CONSOLIDADO_PROVEEDOR}
                  >
                    Consolidado
                  </NavLink>
                  <NavLink
                    onClick={() => setShowNav(false)}
                    className={({ isActive }) =>
                      `text-decoration-none ${isActive && "active"}`
                    }
                    to={PATHS.REPORTES.ESTRACTO_D_PROVEEDOR}
                  >
                    Extracto diario
                  </NavLink>
                  <NavLink
                    onClick={() => setShowNav(false)}
                    className={({ isActive }) =>
                      `text-decoration-none ${isActive && "active"}`
                    }
                    to={PATHS.REPORTES.ESTRACTO_M_PROVEEDOR}
                  >
                    Extracto mensual
                  </NavLink>
                </li>
              </ul>
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="2" className="bg-uvilor-g border-0">
            <Accordion.Button
              as={Card.Header}
              className="bg-uvilor-g text-white accordion-header"
            >
              <span className="icon-truck pe-2"> </span>Conductores
            </Accordion.Button>
            <Accordion.Body>
              <ul>
                <li className="accordion-body">
                  <NavLink
                    onClick={() => setShowNav(false)}
                    className={({ isActive }) =>
                      `text-decoration-none ${isActive && "active"}`
                    }
                    to={PATHS.REPORTES.CONSOLIDADO_CONDUCTOR}
                  >
                    Consolidado
                  </NavLink>
                </li>
                <li className="accordion-body">
                  <NavLink
                    onClick={() => setShowNav(false)}
                    className={({ isActive }) =>
                      `text-decoration-none ${isActive && "active"}`
                    }
                    to={PATHS.REPORTES.ESTRACTO_D_CONDUCTOR}
                  >
                    Extracto diario
                  </NavLink>
                </li>
              </ul>
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="3" className="bg-uvilor-g border-0">
            <Accordion.Button
              as={Card.Header}
              className="bg-uvilor-g text-white accordion-header"
            >
              <span className="icon-office pe-2"></span>Fabrica
            </Accordion.Button>
            <Accordion.Body>
              <ul>
                <li className="accordion-body">
                  {/* Falta establecer rutas de Paths para para sub elementos de la fabrica */}
                  <NavLink
                    onClick={() => setShowNav(false)}
                    className={({ isActive }) =>
                      `text-decoration-none ${isActive && "active"}`
                    }
                    to="elemento-fabrica"
                  >
                    Elementos de fabricación
                  </NavLink>
                </li>
                <li className="accordion-body">
                  <NavLink
                    onClick={() => setShowNav(false)}
                    className={({ isActive }) =>
                      `text-decoration-none ${isActive && "active"}`
                    }
                    to='receta-fabrication'
                  >
                    Recetas de fabricación
                  </NavLink>
                </li>
                <li className="accordion-body">
                  <NavLink
                    onClick={() => setShowNav(false)}
                    className={({ isActive }) =>
                      `text-decoration-none ${isActive && "active"}`
                    }
                    to='registro-fabrica'
                  >
                    Registrar fabricación
                  </NavLink>
                </li>
              </ul>
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="4" className="bg-uvilor-g border-0">
            <Accordion.Button
              as={Card.Header}
              className="bg-uvilor-g text-white accordion-header"
            >
              <span className="icon-stats-bars2 pe-2"></span>Tinas
            </Accordion.Button>
            <Accordion.Body>
              <ul>
                <li className="accordion-body">
                  <NavLink
                    onClick={() => setShowNav(false)}
                    className={({ isActive }) =>
                      `text-decoration-none ${isActive && "active"}`
                    }
                    to="tinas"
                  >
                    Gestionar Tinas
                  </NavLink>
                </li>

              </ul>
            </Accordion.Body>
          </Accordion.Item>
          
          <Accordion.Item eventKey="5" className="bg-uvilor-g border-0">
            <Accordion.Button
              as={Card.Header}
              className="bg-uvilor-g text-white accordion-header"
            >
              <span className="icon-stats-bars pe-2"></span>Reportes


            </Accordion.Button>
            <Accordion.Body>
              <ul>
                <RolElement needScope={SCOPES_BY_ROLES.SCP_0} userRoles={rol}>
                  <li className="accordion-body">
                    <NavLink
                      onClick={() => setShowNav(false)}
                      className={({ isActive }) =>
                        `text-decoration-none ${isActive && "active"}`
                      }
                      to="/reportes-s3"
                    >
                      Visualizador Newman
                    </NavLink>
                  </li>
                  </RolElement>
                <li className="accordion-body">
                  <NavLink
                    onClick={() => setShowNav(false)}
                    className={({ isActive }) =>
                      `text-decoration-none ${isActive && "active"}`
                    }
                    to="/graficas-movimiento"
                  >
                    Gráficas de Movimiento
                  </NavLink>
                </li>
      
      

              <li className="accordion-body"> {/*Alertas Evidelis lo colocó*/}
                <NavLink
                  onClick={() => setShowNav(false)}
                  className={({ isActive }) =>
                    `text-decoration-none ${isActive && "active"}`
                  }
                  to="/alertas-monitoreo"
                >
                  Alertas de Monitoreo
                </NavLink>
              </li>
            </ul>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>

      {screenIsSmall && (
        <div className="mt-auto d-flex mb-2">
          <NavLink
            to="/"
            title="Inicio"
            className={({ isActive }) =>
              `text-decoration-none m-auto ${isActive && "active"}`
            }
          >
            <img
              className="mt-4 mb-5"
              style={{ maxWidth: "200px", height: "auto" }}
              src="/LogoUvilorBlanco.png"
              alt="logo"
            />
          </NavLink>
        </div>
      )}
    </nav>

      {
    showNav && (
      <div
        className="position-absolute"
        onClick={() => setShowNav(false)}
        style={{
          backgroundColor: "#47474760",
          transition: "opacity .8s",
          width: "100vw",
          height: "100vh",
        }}
      ></div>
    )
  }
    </div >
  );
};
